import { gql } from 'apollo-boost';

export const DELETE_DANCER = gql`
  mutation DancerDelete($dancerId: ID!) {
    dancer_delete(input: { id: $dancerId }) {
      clientMutationId
    }
  }
`;
